module.exports = __webpack_public_path__ + "img/dxx.a79c552d.png";